const refactorFoods = (foods, targetBranchId) => {
  const refactoredFoods = []

  foods.forEach(food => {
    const options = []

    food.options.forEach(option => {
      const inventory =
        option.inventories.find(inv =>
          inv.isAvailable &&
          inv.branchId === targetBranchId
        )

      if (!inventory) return

      options.push({
        _id: option._id,
        name: option.name,
        barCode: option.barCode,
        optionListItems: option.optionListItems,
        cost: inventory.cost || 0,
        price: inventory.price || 0,
        salePrice: inventory.salePrice || 0,
        outOfStock: inventory.outOfStock,
        availableQuantity: inventory.availableQuantity,
        stockManagement: inventory.stockManagement,
        isAvailable: inventory.isAvailable,
        branchId: inventory.branchId
      })
    })

    if (options.length === 0) return

    const taxItemIds = []

    food.taxItemIdsPerBranch.forEach(taxItemIdPerBranch => {
      if (!taxItemIdPerBranch.branchIds.includes(targetBranchId)) return

      taxItemIds.push(
        taxItemIdPerBranch.taxItemId
      )
    })

    const taxItems =
      food.taxItems.filter(taxItem =>
        taxItemIds.includes(taxItem._id)
      )

    const specificationIds = []

    food.specificationIdsPerBranch.forEach(specificationIdPerBranch => {
      if (!specificationIdPerBranch.branchIds.includes(targetBranchId)) return

      specificationIds.push(
        specificationIdPerBranch.specificationId
      )
    })

    const specifications =
      food.specifications.filter(specification =>
        specificationIds.includes(specification._id)
      )

    refactoredFoods.push({
      ...food,
      specifications,
      taxItems,
      taxItemIds,
      specificationIds,
      options
    })
  })

  return refactoredFoods
}

export default refactorFoods